export default __webpack_public_path__ + "static/rovo-menu-do-dark-c011f8f837dae539b9b4086b0c969f92.png";